var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareBoldBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_3302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.244 3.99927C16.9643 3.71965 16.608 3.52924 16.2201 3.4521C15.8322 3.37497 15.4301 3.41457 15.0647 3.56591C14.6993 3.71725 14.387 3.97353 14.1672 4.30235C13.9474 4.63117 13.8301 5.01777 13.83 5.41327V6.99927H9C6.61386 7.00191 4.32622 7.95097 2.63896 9.63822C0.951708 11.3255 0.00264685 13.6131 0 15.9993L0 22.9992C0 23.2645 0.105357 23.5188 0.292893 23.7063C0.48043 23.8939 0.734784 23.9992 1 23.9992C1.26522 23.9992 1.51957 23.8939 1.70711 23.7063C1.89464 23.5188 2 23.2645 2 22.9992C2.00159 21.4084 2.63424 19.8832 3.75911 18.7584C4.88399 17.6335 6.40919 17.0008 8 16.9993H13.83V18.5852C13.8301 18.9808 13.9474 19.3673 14.1672 19.6962C14.387 20.025 14.6993 20.2813 15.0647 20.4326C15.4301 20.5839 15.8322 20.6235 16.2201 20.5464C16.608 20.4693 16.9643 20.2789 17.244 19.9992L23.123 14.1203C23.6854 13.5577 24.0014 12.7948 24.0014 11.9993C24.0014 11.2038 23.6854 10.4408 23.123 9.87826L17.244 3.99927Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_3302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareBoldBlack);
export default __webpack_public_path__ + "static/media/shareBoldBlack.c33a275cdfc7379fc6cc3fb59d153181.svg";
export { ForwardRef as ReactComponent };